const getDeeplinkToken = (): string => {
  const params = new URL(window.location.toString()).searchParams;
  const tk = params.get("tk") || window.sessionStorage.getItem("deeplinkTk");

  return tk ? "tk=" + tk : "";
};

export default getDeeplinkToken;
